// extracted by mini-css-extract-plugin
module.exports = {"tab-header-button":"styles-module__tab-header-button___2eic1"};